export default class TimeLogic {

    static timeOffset = 0;

    static updateOffset(serverTime, timezone){
        let date = new Date();
        let tsOffset = Math.round(date.getTime() / 1000) - serverTime;
        let curTimezone = -date.getTimezoneOffset();
        timezone = 180 + timezone * 60;
        let offsetTimezone = (curTimezone - timezone) * 60;
        this.timeOffset = offsetTimezone + tsOffset;
    }

    static getDate(){
        return new Date((new Date()).getTime() - this.timeOffset * 1000);
    }

    static calcPurposeFinishDate(schedule, seconds){
        let curDate = this.getDate();
        let weekDay = curDate.getDay() - 1;
        if (weekDay < 0){
            weekDay = 6;
        }
        let days = 0;
        while (seconds > 0){
            days++;
            let curHours = schedule[weekDay][1] - schedule[weekDay][0];
            if (curHours < 2){
                curHours = 0;
            }
            weekDay++;
            if (weekDay > 6){
                weekDay = 0;
            }
            if (curHours < 2){
                continue;
            }
            seconds -= curHours * 3600 * 0.85;
        }
        return new Date(curDate.getTime() + days * 86400000);
    }
}